import React from "react";
import ServerErrorImg from "../assets/image/Server Error.svg";
function ServerError() {
  return (
    <>
    <div className="d-none d-xl-block d-lg-block d-md-block">
      <img
        src={ServerErrorImg}
        className=""
        style={{ width: "35%", marginLeft: "30%" }}
      />
      <div className=" card d-none d-xl-block mx-auto" style={{width: "90%"}}>
        <h2 className="p-2 text-center">
          The website is hosted in a free platform. It will be available only on the
          first 21 Days of the Month. 
          <br/>
          The free credits for the month got over.
          Kindly come and visit on the 1st day of next month.
        </h2>
      </div>
      <div className=" card d-none d-xl-none d-lg-block">
        <h4 className="p-2 text-center">
          The website is hosted in a free platform. It will be available only on the
          first 21 Days of the Month. 
          <br/>
          The free credits for the month got over.
          Kindly come and visit on the 1st day of next month.
        </h4>
      </div>
      <div className="card d-block d-xl-none d-lg-none d-md-block">
        <h6 className="p-2 text-center">
          The website is hosted in a free platform. It will be available only on the
          first 21 Days of the Month. 
          <br/>
          The free credits for the month got over.
          Kindly come and visit on the 1st day of next month.
        </h6>
      </div>

      </div>
      <div className="d-block d-xl-none d-lg-none d-md-none">
      <img
        src={ServerErrorImg}
        className=""
        style={{ }}
      />
      <div className="card">
        <h5 className="p-2 text-center">
          The website is hosted in a free platform. It will be available only on the
          first 21 Days of the Month. 
          <br/>
          The free credits for the month got over.
          Kindly come and visit on the 1st day of next month.
        </h5>
      </div>

      </div>
    </>
  );
}

export default ServerError;
